import { LuLayoutDashboard } from "react-icons/lu";
import { NavLink } from "react-router-dom";
import { GiMagicPalm } from "react-icons/gi";

export default function MainNavigation() {
  return (
    <div className="w-full h-screen bg-customBlue px-5 overflow-y-auto">
      {/* <div className="w-full">
        <img src={logo} alt="logo sis" className="w-[150px]" />
      </div> */}
      <h1 className="text-white mt-10 text-base text-opacity-50 ml-2 uppercase">
        Main Menus
      </h1>
      <div className="flex flex-col justify-start items-center mt-3">
        <NavItem name={"Dashboard"} url={"/"}>
          <LuLayoutDashboard color="white" />
        </NavItem>
      </div>
      <div className="flex flex-col justify-start items-center mt-3">
        <NavItem name={"Palm Data"} url={"/palm"}>
          <GiMagicPalm color="white" />
        </NavItem>
      </div>
    </div>
  );
}

export function NavItem({ children, name, url }) {
  return (
    <NavLink
      to={url}
      className={({ isActive }) =>
        isActive
          ? "bg-customOrange pl-5 h-[50px] w-full text-white rounded-xl flex justify-start items-center"
          : "pl-5 h-[50px] w-full text-white rounded-xl flex justify-start items-center text-opacity-50"
      }
    >
      <span className="inline-flex gap-3 justify-start items-center">
        {children}
        <p>{name}</p>
      </span>
    </NavLink>
  );
}
